<template>
    <div
        role="option"
        :aria-selected="isSelected"
        class="survey-step-question-option"
    >
        <v-list-item
            class="mr:flex mr:justify-between mr:items-center mr:relative mr:pr-14"
            tabindex="0"
            :aria-label="text"
            role="checkbox"
            :aria-checked="isSelected"
            @click="emits('selectOption')"
        >
            <span>
                {{ text }}
            </span>
            <span class="survey-step-question-option__icon mr:absolute mr:h-8 mr:right-3">
                <span
                    class="material-symbols-outlined mr:text-icon"
                    data-cy="activity-row-icon"
                >
                    {{ isSelected ? 'check_circle' : 'circle' }}
                </span>
            </span>
        </v-list-item>
    </div>
</template>

<script setup>
const emits = defineEmits(['selectOption'])

defineProps({
    isSelected: {
        type: Boolean,
        required: true
    },
    text: {
        type: String,
        required: true
    }
})
</script>
